import React, { useEffect, useState } from 'react'
import "./CategoriesBar.css"
import { LinearProgress } from '@mui/material';
import axiosApiInstance from '../axios';
import CAlertBox from '../CAlertBox/CAlertBox';



const CategoriesBar = (props) => {


    const [keywords, setKeywords] = useState([])
    const [isActive, setIsActive] = useState();
    const [visible, setVisible] = useState();
    const [alertMessage, setAlertMessage] = useState('');


    const fetchedToken = localStorage.getItem('token');


    useEffect(() => {
        if (fetchedToken) {
            axiosApiInstance.get(`/category`)
                .then(resp => setKeywords(resp.data.data)).catch(err => {
                    // alert(err, 'Try again! Please Refresh the Page')
                    setAlertMessage('Try again! Please Refresh the Page');
                })
        }
        else {
            const reloadCount = sessionStorage.getItem('reloadCount');
            if (reloadCount < 2) {
                sessionStorage.setItem('reloadCount', String(reloadCount + 1));
                window.location.reload();
            } else {
                sessionStorage.removeItem('reloadCount');
            }
        }
    }, [])

    useEffect(() => {
        props.name.length < 1 ? setVisible(false) : setVisible(true)
    }, [props.name])


    const filCat = (name, id) => {
        props.setCat(name)
        setIsActive(id)
        setVisible(true)
    }


    const removeCat = () => {
        props.setCat("")
        setIsActive()
        setVisible(false);
    }



    return (
        <div className="categories">
            {keywords < 1 ? <LinearProgress /> :
                keywords.map(word => (
                    <span className={isActive === word.id ? "activeness" : ""} key={word.id} onClick={() => filCat(word.name, word.id)}>{word.name}</span>
                ))
            }

            {visible ? <span onClick={removeCat}>All Categories</span> : " "}
            <CAlertBox open={alertMessage} message={alertMessage} handleClose={() => setAlertMessage('')} />

        </div>
    )
}

export default CategoriesBar
